import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DebriefTabs = ({ game_id = null }) => {
  // Hooks
  const { t } = useTranslation();

  return [
    <NavLink
      key='gd-setup'
      to={`/games/${game_id}/setup`}
      className={({ isActive }) =>
        isActive
          ? 'btn btn-primary py-0 fs-3 fw-light me-3'
          : 'btn btn-light text-secondary py-0 fs-3 fw-light me-3'
      }>
      {t('Setup')}
    </NavLink>,
    <NavLink
      key='gd-debrief'
      to={`/games/${game_id}/debrief/overview`}
      className={({ isActive }) =>
        isActive
          ? 'btn btn-primary py-0 fs-3 fw-light me-3'
          : 'btn btn-light text-secondary py-0 fs-3 fw-light me-3'
      }>
      {t('Debrief')}
    </NavLink>,
  ];
};
export default DebriefTabs;
